import {
  Component,
  OnInit,
  VERSION,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { ToastrService } from 'ngx-toastr';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VideoCategoryManageComponent } from '../video-category-manage/video-category-manage.component';
import { BlogManageCategoryComponent } from '../blog-manage-category/blog-manage-category.component';
@Component({
  selector: 'app-add-blogs',
  templateUrl: './add-blogs.component.html',
  styleUrls: ['./add-blogs.component.scss'],
})
export class AddBlogsComponent implements OnInit {
  ckeConfig: any;
  roledata: any;
  Category: any;
  name: any;
  remark: any;
  imageSrc: any;
  uploadedImage: File;
  isSingleUploaded = false;
  Language: any;
  maincategory;
  listcategory;
  title: any;
  form: FormGroup;
  categorylist = false;
  isButtonVisible = false;
  languageList = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];

  rolebased = [{ role: 'Crop Practices' }, { role: 'Articles' }];

  @ViewChild('inputFile') myInputVariable: ElementRef;
  categorylistdata = [{ list: 'Blog1' }, { list: 'Blog1' }, { list: 'Blog3' }];

  editor = ClassicEditor;

  data: any = `<p>Hello, world!</p>`;
  submitted = false;
  isChecked = false;
  savescheme = false;
  UserAgentDetection = `
  <html>
<head>
<style>
#outer-div {
// width: 100%;
// text-align: center;
// background-color: #0666a3
width: 100%;
text-align: center;
background-color: #0666a3;
position: -webkit-sticky;
position: sticky;
top: 0;
padding: 30px;
font-size: 20px;
}
#inner-div {
display: inline-block;
margin: 0 auto;
padding: 3px;
background-color: #8ebf42
}
</style>


<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>
</head>

<body>
<script>
var browserName = (function (agent) {
switch (true) {
case agent.indexOf("kalpavriksha-mobile-app") > -1: return "kalpavriksha-mobile-app"
 case agent.indexOf("edge") > -1: return "MS Edge";
 case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
 case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
 case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
 case agent.indexOf("trident") > -1: return "MS IE";
 case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
 case agent.indexOf("safari") > -1: return "Safari";
 default: return "other";
}
})
(window.navigator.userAgent.toLowerCase());

//For Hiding alert Inside Mobile PKF App and for rest browser it will display alert
if (browserName != "kalpavriksha-mobile-app") {

document.getElementById('input').innerHTML = "You are using " + browserName + " browser " ;
} 
else
{
document.getElementById('outer-div').style.display = "none";
}
// new code
var now = new Date(). valueOf();
setTimeout(function () {
if (new Date(). valueOf() – now > 100) return;
window. location = “https://play.google.com/store/apps/details?id=com.pkf.kalpavriksha”;
}, 25);
window. location = “appname://com.pkf.kalpavriksha”;

//new code end
</script>
</body>
</html> `;


  constructor(private router: Router,
    public _userService: UserManagementService,
    private fb: FormBuilder,
    public toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {
    this.getAlluser();
    this.getallimage();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      type: [''],
      categorydata: [],
      titledata: ['', [Validators.required]],
      Language: ['', [Validators.required]],
      ckeditordata: [, [Validators.required]],
      remark: [''],
      image: new FormControl('', [Validators.required]),
    });

    /* Category List  */
    this._userService.getblogcategory().subscribe((category) => {
      this.listcategory = category;
      this.maincategory = this.listcategory.result.data;
    });
    /* Category List  */

    this.ckeConfig = {
      //easyimage
      allowedContent: true,
      extraPlugins:
        'easyimage,uploadimage,dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,' +
        'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
        'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
        'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
        'font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,' +
        'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
        'maximize,newpage,pagebreak,pastefromword,pastetext,preview,print,' +
        'removeformat,resize,save,menubutton,scayt,selectall,showblocks,' +
        'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
        'tabletools,templates,toolbar,undo,wsc,wysiwygarea,',
    };

    this.ckeConfig = {
      extraPlugins: 'embed,autoembed,image2',
      height: 500,
      // Load the default contents.css file plus customizations for this sample.
      contentsCss: [
        // 'http://cdn.ckeditor.com/4.17.1/full-all/contents.css',
        'https://ckeditor.com/docs/ckeditor4/4.17.1/examples/assets/css/widgetstyles.css',
      ],
      // Setup content provider. See https://ckeditor.com/docs/ckeditor4/latest/features/media_embed
      embed_provider:
        '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
      // Configure the Enhanced Image plugin to use classes instead of styles and to disable the
      // resizer (because image size is controlled by widget styles or the image takes maximum
      // 100% of the editor width).
      image2_alignClasses: [
        'image-align-left',
        'image-align-center',
        'image-align-right',
      ],
      image2_disableResizer: false,
      removeButtons:
        'PasteFromWord,Flash,Anchor,Unlink,HiddenField,Button,Select,Form,Checkbox,Textarea,TextField,Radio,IFrame,Source,Save,NewPage,Templates,BidiLtr,BidiRtl,Language,PageBreak,Iframe,About',
    };

  }
  get f() {
    return this.form.controls;
  }
  doSomething(data) {
    if (data.value == 'Crop Practices') {
      this.categorylist = true;
    } else if (data.value == 'Articles') {
      this.categorylist = false;
    }
  }
  onEditorChange(event: any) { }

  onChange(event: any): void { }
  response;
  catid;

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.spinner.hide();
      this.toastr.error('Please fill the form');
      return false;
    } else {
      this.spinner.show();
      const formData: FormData = new FormData();

      formData.append('Title', this.form.get('titledata').value),
      formData.append('Image', this.form.get('image').value),
      formData.append('categoryId', this.form.get('categorydata').value),
      formData.append('Language', this.form.get('Language').value),
      formData.append('details', this.UserAgentDetection + this.name),
      formData.append('Remark', this.form.get('remark').value),

      this._userService.postblogdata(formData).subscribe((data: any) => {
        this.response = data;
        this.spinner.hide();
        this.toastr.success(data.result.message);
      }, (err: any) => {
        this.spinner.hide();
        console.log("err is getting something1", err)
      });
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/add-blog']);
      });
    }
  }

  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-z A-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  newsFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    this.form.get('image')?.setValue(this.uploadedImage);
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => (this.imageSrc = reader.result);

      reader.readAsDataURL(file);
    }
  }
  resetButton() {
    this.remark = '';
    this.imageSrc = '';
    this.form.reset();
  }

  preview() {
    let wind = window.open('', 'someName', 'resizable,scrollbars');
    wind.document.body.innerHTML = this.name;
    // wind.document.title = "TEST";
    //  wind.focus();
  }

  listPage() {
    this.router.navigate(['/add-blog-list']);
  }
  /*=================================================================== */
  userdata;
  userlist:any;
  dataresult;
  getAlluser() {
    var postdata = {
      userId: '',
      userRole: 'Trader',
      name: '',
      state: '',
      documentStatus: '',
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: '',
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list[0].docuements;
      this.dataresult = this.userlist?.documentUrl;
    });
  }
  url;
  onclick(testdata) {
    this.url = testdata.srcElement.src;
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', this.url);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }
  removeFile() {
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }
  manageCategory() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    this.dialog.open(BlogManageCategoryComponent, dialogConfig);
  }

  fileData; finaldata;
  lastFilePath: any;
  file1: any;
  processImage(event) {
    this.isButtonVisible = true;
    let splitfile = event.target.files;

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: [] = event.target.files;
    this.file1 = [];


    for (let i = 0; i < splitfile.length; i++) {
      let type = splitfile[i].type.split('/');
      if (!(type[1] == "jpeg" || type[1] == "jpg" || type[1] == "png" || type[1] == "pdf")) {

        this.finaldata = 0
        this.myInputVariable.nativeElement.value = "";
        this.savescheme = false;
        this.isButtonVisible = false;
        this.toastr.warning(
          'Accepted File Formats PDF,PNG.JPG and JPEG only',
          'Info',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (splitfile[i].size >= 5242900) {
        this.myInputVariable.nativeElement.value = '';
        this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
          timeOut: 3000,
        });
        return;
      } else {
        this.file1.push(splitfile[i]);
      }
    }
    this.finaldata = this.file1;
    this.savescheme = true;
    this.submit_file();
  }

  submit_file() {
    if (this.finaldata != undefined && this.finaldata != "") {

      let selectedFiles = []
      for (let i = 0; i < this.finaldata.length; i++) {
        selectedFiles.push(this.finaldata[i]);
      }

      const postdata = new FormData();
      selectedFiles.forEach((f) => postdata.append('postblogimages', f));

      this._userService.imageuploadblog(postdata).subscribe(data => {

        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });

      })
      setTimeout(() => {
        this.getallimage();
      }, 2000);
    }
    this.removeFile();
  }

  resultdata;
  imageurllisting;
  newImageurllisting;
  isSelected = false;
  getallimage() {
    let isSelected = false;
    // let newImageurllisting = []
    this._userService.getuploadimage().subscribe((data) => {
      this.resultdata = data;
      this.imageurllisting = this.resultdata.result.data;
      // this.ngOnInit();
      this.newImageurllisting = this.imageurllisting.map(function (el) {
        var o = Object.assign({}, el);
        o.isSelected = false;
        return o;
      });
      this.cd.detectChanges();
    });
  }

  deleteImage() {
    this.isChecked = false;
    let totalDeleteItem = [];
    this.newImageurllisting.forEach((item) => {
      if (item.isSelected == true) {
        totalDeleteItem.push(item.blogImageID);
      }
    })
    if (totalDeleteItem.length == 0) {
      alert('Please select images for delete.');
    } else if (totalDeleteItem.length == 1) {
      let text = confirm('Are you sure you want to delete this image?');
      if (text == true) {
        var postdata = totalDeleteItem;
        this._userService.deleteBlogImages(postdata).subscribe((result) => {
          this.response = result;
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
          this.getallimage();
        });
      } else {
        this.newImageurllisting.forEach((item) => {
          item.isSelected = false;
        });
      }
    } else {
      let text = confirm('Are you sure you want to delete these images?');
      if (text == true) {
        var postdata = totalDeleteItem;
        this._userService.deleteBlogImages(postdata).subscribe((result) => {
          this.response = result;
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
          this.getallimage();
        });
      } else {
        this.newImageurllisting.forEach((item) => {
          item.isSelected = false;
        });
      }
    }
  }
}
